/*
Cabinet Catches

  --type <string> | ['Magnetic', 'Ball', 'Spring', 'Elbow']
  --pair <boolean::switch> | ['Pair', 'Individual']
  --single <boolean::switch> | ['Single', 'Double']
*/

import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Catches'
const id = '0xChW2ldWBeo2I3j9Xnf'

export default {
  name,
  id,
  filters,
  headers,
  form
}
